/**
 * Create a new intersection observer
 * @param {Object} options - params to set observer
 * @param {HTMLElement} target - element as a reference
 * @returns {Object} - observer
 */
export const setIntersectionObserver = (options, target) => {
  const observer = new IntersectionObserver((entries) => {
    const { isIntersecting } = entries[0];
    window.isIntersecting = isIntersecting;
  }, options);

  observer.observe(target);
  return observer;
}

/**
 * Create a new mutation observer
 * @param {function} callback - The callback to be executed
 * @param {HTMLElement} target - The element as a reference
 * @param {Object} config - The configuration to observe mutation
 * @returns {Object} - observer
 */
export const setMutationObserver = (callback, target, config) => {
  const observer = new MutationObserver(callback);

  observer.observe(target, config);

  return observer;
}
